import { EuiButtonIcon } from "@inscopix/ideas-eui";
import { Tooltip } from "components/Tooltip/Tooltip";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";

interface QuickActionToggleRowJoinableProps {
  tableId: string;
  rowId: string;
  isJoinable: boolean;
  readOnly?: boolean;
}

export const QuickActionToggleRowJoinable = ({
  tableId,
  rowId,
  isJoinable,
  readOnly,
}: QuickActionToggleRowJoinableProps) => {
  const updateRow = useDataTableContext((s) => s.updateAnalysisTableRow);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    const { error } = await updateRow({
      tableId,
      rowId,
      isJoinable: !isJoinable,
    });
    setIsLoading(false);
    if (error !== undefined) {
      addUtilityToastFailure("Failed to update row");
    }
  };

  return (
    <Tooltip content={isJoinable ? "Hide row from joins" : "Show row in joins"}>
      <EuiButtonIcon
        id="QuickActionToggleRowJoinable"
        aria-label={isJoinable ? "Hide row from joins" : "Show row in joins"}
        size="xs"
        color={isJoinable ? "primary" : "text"}
        iconType={isJoinable ? "eye" : "eyeClosed"}
        onClick={() => void handleClick()}
        disabled={readOnly ?? false}
        isLoading={isLoading}
      />
    </Tooltip>
  );
};
